var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return _c('el-card', {
    class: {
      'list-view__card--multi': _vm.multiCol
    },
    attrs: {
      "body-style": _vm.bodyStyle
    }
  }, [_c('div', {
    staticClass: "list-view__card"
  }, [_vm._t("image-box", function () {
    return [_vm.data.thumbnail ? _c('el-image', {
      staticClass: "list-view__card__thumbnail",
      style: _vm.thumbStyle,
      attrs: {
        "src": _vm.data.thumbnail,
        "preview-src-list": _vm.data.pictures,
        "fit": "cover"
      }
    }) : _vm._e()];
  }), _c('div', {
    staticClass: "list-view__card__content",
    on: {
      "click": _vm.handleClick
    }
  }, [_c('div', {
    staticClass: "list-view__card__header",
    class: {
      'el-bb-color-border': !_vm.multiCol
    }
  }, [_c('div', {
    staticClass: "list-view__card__title",
    style: _vm.titleStyle
  }, [_vm._v(" " + _vm._s(_vm.transformedTitle) + " ")]), _c('div', {
    staticClass: "list-view__card__right"
  }, [_vm._t("header-right")], 2)]), _c('div', {
    staticClass: "list-view__card__body el-color-text-secondary"
  }, [_vm._t("body")], 2)])], 2)]);
};

var staticRenderFns = [];
export { render, staticRenderFns };